import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './es';

// Español completo; el inglés (Jamaica) se agrega en la Etapa 1b con las mismas llaves.
void i18n.use(initReactI18next).init({
  resources: { es: { translation: es } },
  lng: 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false }
});

export default i18n;
